import { createSlice, PayloadAction } from '@reduxjs/toolkit';


interface HaptikState {
  isHaptikEnabled: boolean;
  showLogin: boolean;
}

const initialState: HaptikState = {
  isHaptikEnabled: false,
  showLogin: false,
};

// Create the slice
const haptikSlice = createSlice({
  name: 'haptik', 
  initialState,
  reducers: {
    setHaptikEnabled: (state, action: PayloadAction<boolean>) => {
      state.isHaptikEnabled = action.payload;
    },
    setShowLogin: (state, action: PayloadAction<boolean>) => {
      state.showLogin = action.payload;
    },
  },
});

// Export actions
export const { setHaptikEnabled, setShowLogin } = haptikSlice.actions;


export default haptikSlice.reducer;